<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="spin-icon">
    <rect
      opacity="0.87"
      x="1.34375"
      y="2.75781"
      width="2"
      height="4"
      rx="1"
      transform="rotate(-45 1.34375 2.75781)"
      fill="#3C3C43"
      fill-opacity="0.6"
    />
    <rect
      opacity="0.75"
      x="4"
      y="6"
      width="2"
      height="4"
      rx="1"
      transform="rotate(90 4 6)"
      fill="#3C3C43"
      fill-opacity="0.6"
    />
    <rect
      opacity="0.63"
      x="4.17188"
      y="8.41406"
      width="2"
      height="4"
      rx="1"
      transform="rotate(45 4.17188 8.41406)"
      fill="#3C3C43"
      fill-opacity="0.6"
    />
    <rect opacity="0.51" x="6" y="10" width="2" height="4" rx="1" fill="#3C3C43" fill-opacity="0.6" />
    <rect
      opacity="0.39"
      x="8.41406"
      y="9.82812"
      width="2"
      height="4"
      rx="1"
      transform="rotate(-45 8.41406 9.82812)"
      fill="#3C3C43"
      fill-opacity="0.6"
    />
    <rect
      opacity="0.27"
      x="14"
      y="6"
      width="2"
      height="4"
      rx="1"
      transform="rotate(90 14 6)"
      fill="#3C3C43"
      fill-opacity="0.6"
    />
    <rect
      opacity="0.15"
      x="11.2422"
      y="1.34375"
      width="2"
      height="4"
      rx="1"
      transform="rotate(45 11.2422 1.34375)"
      fill="#3C3C43"
      fill-opacity="0.6"
    />
    <rect x="6" width="2" height="4" rx="1" fill="#3C3C43" fill-opacity="0.6" />
  </svg>
</template>
<style lang="scss" scoped>
.spin-icon {
  animation: spin 2s linear infinite;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
